import { PiArrowsClockwiseLight, PiQuestionLight } from 'react-icons/pi';
import { IconButton } from '../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useTranslation } from 'react-i18next';

const TooltipMidiInput = () => {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton noHover className='hover:text-accent-blue'>
          <PiQuestionLight size={20} />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent className='w-80' sideOffset={110} side='left'>
        <div className='flex justify-between gap-4 m-2'>
          <div className='space-y-1'>
            <p className='text-sm'>
              {t('tooltip.midiInput.midi_input_help_1')}
              <span className='inline-flex align-middle mx-1'>
                <PiArrowsClockwiseLight
                  size={20}
                  className='fill-accent-blue'
                />
              </span>
              {t('tooltip.midiInput.midi_input_help_2')}
              <br />
              {t('tooltip.midiInput.midi_input_help_3')}
            </p>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipMidiInput;
